import { Text } from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'
import React from 'react'
import { CsPrimaryApplicationIcon } from '../../legacy-design-system/icons'
import { LoadingMaskRectangle } from '../../legacy-design-system/loading-masks'
import { PresenceIndicator } from '../presence-indicator'
import { ApplicationModule } from './api/get-application-modules'
import { applicationColumnWidth } from './application-modules-grid'

export const applicationCellLoadingMaskTestId =
  'application-cell-loading-mask-test-id'
export const applicationCellTestId = 'application-cell-test-id'

export function applicationColumnCellRenderer({
  isLoading,
  rowData: { name, language, primary, status, lastSeen }
}: {
  isLoading: boolean
  rowData: ApplicationModule
}) {
  return isLoading ? (
    <LoadingMaskRectangle
      dataTestId={applicationCellLoadingMaskTestId}
      height={15}
      width={applicationColumnWidth - 25}
    />
  ) : (
    <div data-testid={applicationCellTestId}>
      <div
        className={css`
          display: flex;
          align-items: center;
        `}
      >
        <div
          className={css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 85%;
          `}
        >
          {name}
        </div>
        {primary && (
          <div
            className={css`
              padding-top: 2px;
              padding-left: 5px;
            `}
          >
            <CsPrimaryApplicationIcon />
          </div>
        )}
        <div
          className={css`
            padding-top: 2px;
            padding-left: 7px;
          `}
        >
          <PresenceIndicator
            online={status === 'online'}
            lastActivity={Number.parseInt(lastSeen, 10)}
          />
        </div>
      </div>
      <div
        className={css`
          margin-top: 5px;
        `}
      >
        <Text color="neutral60" font="metadata">
          {language}
        </Text>
      </div>
    </div>
  )
}
